/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedCategoryRequest
 */
export interface APIPatchedCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedCategoryRequest
     */
    name?: string;
}

/**
 * Check if a given object implements the APIPatchedCategoryRequest interface.
 */
export function instanceOfAPIPatchedCategoryRequest(value: object): value is APIPatchedCategoryRequest {
    return true;
}

export function APIPatchedCategoryRequestFromJSON(json: any): APIPatchedCategoryRequest {
    return APIPatchedCategoryRequestFromJSONTyped(json, false);
}

export function APIPatchedCategoryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedCategoryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function APIPatchedCategoryRequestToJSON(value?: APIPatchedCategoryRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

